import {
    Container,
    Typography,
    Box,

} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import EventListSection from "../../sections/_dashboard/EventListSection";
import SkillSelectionSection from "../../sections/_dashboard/SkillSelectionSection";
import SkillInputSection from "../../sections/_dashboard/SkillInputSection";

export default function TestSections() {
    const { t } = useTranslation();

    let lang = getLang();

    const event =
    {
        "id": 124,
        "name_en": "體適能25/26 #1",
        "name_zh": "體適能25/26 #1",
        "type": "org",
        "organization_id": 154,
        "start_at": "2025-10-20 04:55:15",
        "end_at": "2025-10-24 16:00:00",
        "participant_org": [
            154
        ],
        "skill_setting": null,
        "leaderboard_skill_setting": [
            "fit_situp",
            "fit_sitnreach",
            "fit_15mrun",
            "fit_handgrip"
        ],
        "leaderboard_dashboard_setting": {},
        "campaign": "",
        "created_at": "2025-10-20 12:56:25",
        "updated_at": "2025-10-20 12:56:25",
        "deleted_at": "",
        "timeslotList": [
            {
                "id": 1,
                "timeslot_caption": "活動時段",
                "start_at": "00:00",
                "end_at": "23:15",
                "break_time": false
            }
        ]
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h3">Test Simple</Typography>


            <div>
                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
            </div>
            <SkillSelectionSection event={event} />
        </Container>
    )
}
